"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmlsCheckbox = void 0;
const react_1 = __importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const className_1 = require("../../utils/className");
exports.SmlsCheckbox = (_a) => {
    var { id = '', idLabel, checked, onChange, onClick, name = '', label = '', iconUndefined, className, isError = false, errorMessage, dark, value, filterNumber, labelStyle = 'caption' } = _a, params = __rest(_a, ["id", "idLabel", "checked", "onChange", "onClick", "name", "label", "iconUndefined", "className", "isError", "errorMessage", "dark", "value", "filterNumber", "labelStyle"]);
    react_1.useEffect(() => {
        if (id && idLabel) {
            const arrLabelHtml = document.querySelectorAll(`[for=${id}]`);
            if (arrLabelHtml.length > 1) {
                return console.error(`Duplicated id on ${id}, this is a problem, please fix it`);
            }
            arrLabelHtml[0].setAttribute('id', idLabel);
        }
        return undefined;
    }, [id, idLabel]);
    const renderLabel = () => (react_1.default.createElement("span", { className: `smls-chk-label-${labelStyle}` },
        label,
        filterNumber !== undefined && (react_1.default.createElement("span", { className: "smls-chk-label-filter" }, `(${filterNumber})`))));
    return (react_1.default.createElement(reactstrap_1.CustomInput, Object.assign({ id: id, name: name, onChange: onChange, onClick: onClick, label: renderLabel(), type: "checkbox", checked: checked, className: className_1.mapToCssModules([
            className,
            iconUndefined ? 'smls-chk-undefined' : '',
            !isError ? '' : 'error',
            !errorMessage ? 'without-error' : '',
            !dark ? '' : 'dark',
            'custom-checkbox',
        ]), value: value }, params),
        errorMessage ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("br", null),
            react_1.default.createElement("span", { className: `smls-chk-error ${dark && 'dark'}` }, errorMessage))) : null,
        react_1.default.createElement("div", { className: "smls-chk-out" })));
};
//# sourceMappingURL=index.js.map